<template>
  <div class="m-2 flex flex-row items-center">
    <div
      :class="`p-4 mr-4 rounded shadow cursor-pointer ${
        yes ? 'bg-green-300' : 'bg-gray-100'
      }`"
      @click="toggleYes"
    >
      &#10004;
    </div>
    <div
      :class="`p-4 rounded shadow cursor-pointer ${
        no ? 'bg-red-100' : 'bg-gray-100'
      }`"
      @click="toggleNo"
    >
      &#10006;
    </div>
  </div>
</template>
<script>
import { defineComponent } from "@vue/runtime-core";
export default defineComponent({
  name: "BooleanFilter",
  data() {
    return {
      yes: false,
      no: false,
    };
  },
  methods: {
    toggleYes() {
      this.yes = !this.yes;
      this.no = false;
      this.params.onModelChange(this.yes ? { value: true } : null);
    },

    toggleNo() {
      this.no = !this.no;
      this.yes = false;
      this.params.onModelChange(this.no ? { value: false } : null);
    },

    refresh(newParams) {
      if (newParams.model === null || newParams.model === undefined) {
        this.yes = false;
        this.no = false;
      } else {
        this.yes = newParams.model.value === true;
        this.no = newParams.model.value === false;
      }
    },
  },
  computed: {
    active() {
      return this.yes || this.no;
    },
  },
});
</script>
